module.exports = __webpack_public_path__ + "static/media/image_13.5475d03c.png";